function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 8,
  fill: "#1B9C2E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9062 9.56931L10.7865 14.9022C10.7567 14.9332 10.7214 14.9578 10.6826 14.9746C10.6438 14.9914 10.6021 15 10.5601 15C10.518 15 10.4764 14.9914 10.4375 14.9746C10.3987 14.9578 10.3634 14.9332 10.3337 14.9022L8.09377 12.5691C8.03373 12.5065 8 12.4217 8 12.3333C8 12.2448 8.03373 12.16 8.09377 12.0975C8.15382 12.0349 8.23525 11.9998 8.32016 11.9998C8.40508 11.9998 8.48651 12.0349 8.54655 12.0975L10.5601 14.1952L15.4534 9.09768C15.5135 9.03514 15.5949 9 15.6798 9C15.7647 9 15.8462 9.03514 15.9062 9.09768C15.9663 9.16022 16 9.24505 16 9.33349C16 9.42194 15.9663 9.50677 15.9062 9.56931Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var SvgGreenCheck = function SvgGreenCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green_check.2fd34223.svg";
export { ForwardRef as ReactComponent };